import { render } from "./DexDataTable.vue?vue&type=template&id=68145304"
import script from "./DexDataTable.vue?vue&type=script&lang=js"
export * from "./DexDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__